import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { ActivateCode } from '@routes/ActivateCodeRoutes';
import { AppSettings } from '@routes/AppSettingsRoutes';
import { AutomaticCampaignRoutes } from '@routes/AutomaticCampaignRoutes';
import { BonusesPendingReviewRoutes } from '@routes/BonusesPendingReviewRoutes';
import { BonusRoutes } from '@routes/BonusRoutes';
import { CampaignActivityRoutes } from '@routes/CampaignActivityRoutes';
import { CampaignMonitorRoutes } from '@routes/CampaignMonitorReport';
import { CodeCampaignRoutes } from '@routes/CodeCampaignRoutes';
import { GiveBonusManagement } from '@routes/GiveBonusRoutes';
import { IframeMode } from '@routes/IframeModeRoutes';
import { PlayerBonusesRoutes } from '@routes/PlayerBonusesRoutes';
import { PlayerCampaignsRoutes } from '@routes/PlayerCampaignsRoutes';
import { PlayerCodesRoutes } from '@routes/PlayerCodesReportRoutes';
import { PlayerOffersRoutes } from '@routes/PlayerOffersReportRoutes';
import { ScheduledCampaignRoutes } from '@routes/ScheduledCampaigns';

import { ErrorComponent, Suspendable } from '@components';
import { ROUTES } from '@constants';

const MainLayout = Suspendable(
  lazy(() =>
    import('@layout/MainLayout').then((module) => ({
      default: module.default,
    }))
  )
);

const ModuleRoutes: RouteObject = {
  path: ROUTES.ROOT,
  element: <MainLayout />,
  errorElement: <ErrorComponent />,
  children: [
    ...BonusRoutes,
    ...GiveBonusManagement,
    ...ActivateCode,
    ...AutomaticCampaignRoutes,
    ...ScheduledCampaignRoutes,
    ...PlayerBonusesRoutes,
    ...PlayerCampaignsRoutes,
    ...CampaignActivityRoutes,
    ...BonusesPendingReviewRoutes,
    ...CampaignMonitorRoutes,
    ...PlayerCodesRoutes,
    ...PlayerOffersRoutes,
    ...AppSettings,
    ...CodeCampaignRoutes,
    ...IframeMode,
  ],
};

export default ModuleRoutes;
